// @flow

import {
  COMPANY_ROLE__FOUNDER,
  COMPANY_ROLE__ESTABLISHED_ENTREPRENEUR,
  COMPANY_ROLE__SUCCESSOR,
  COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__LOSS,
  COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__ZERO,
  COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__1_TO_10_THOUSAND,
  COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__10_TO_20_THOUSAND,
  COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__20_TO_30_THOUSAND,
  COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__30_TO_40_THOUSAND,
  COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__40_TO_50_THOUSAND,
  COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__50_TO_75_THOUSAND,
  COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__75_TO_100_THOUSAND,
  COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__100_TO_250_THOUSAND,
  COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__250_TO_500_THOUSAND,
  COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__500_TO_750_THOUSAND,
  COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__500_THOUSAND_TO_1_MILLION,
  COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__750_THOUSAND_TO_1_MILLION,
  COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__1_MILLION_TO_2_5_MILLION,
  COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__1_TO_2_5_MILLION,
  COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__2_5_TO_5_MILLION,
  COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__5_TO_10_MILLION,
  COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__10_TO_25_MILLION,
  COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__25_TO_50_MILLION,
  COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__10_TO_50_MILLION,
  COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__MORE_THAN_50_MILLION,
  COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__50_TO_100_MILLION,
  COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__MORE_THAN_100_MILLION,
  COMPANY__TURNOVER_CLASS__0_TO_10_THOUSAND,
  COMPANY__TURNOVER_CLASS__10_TO_20_THOUSAND,
  COMPANY__TURNOVER_CLASS__20_TO_30_THOUSAND,
  COMPANY__TURNOVER_CLASS__30_TO_40_THOUSAND,
  COMPANY__TURNOVER_CLASS__40_TO_50_THOUSAND,
  COMPANY__TURNOVER_CLASS__50_TO_75_THOUSAND,
  COMPANY__TURNOVER_CLASS__75_TO_100_THOUSAND,
  COMPANY__TURNOVER_CLASS__100_TO_250_THOUSAND,
  COMPANY__TURNOVER_CLASS__250_TO_500_THOUSAND,
  COMPANY__TURNOVER_CLASS__500_THOUSAND_TO_1_MILLION,
  COMPANY__TURNOVER_CLASS__1_MILLION_TO_2_5_MILLION,
  COMPANY__TURNOVER_CLASS__2_5_TO_5_MILLION,
  COMPANY__TURNOVER_CLASS__5_TO_10_MILLION,
  COMPANY__TURNOVER_CLASS__10_TO_25_MILLION,
  COMPANY__TURNOVER_CLASS__25_TO_50_MILLION,
  COMPANY__TURNOVER_CLASS__50_TO_100_MILLION,
  COMPANY__TURNOVER_CLASS__MORE_THAN_100_MILLION,
  REAL_ESTATE__NEW_BUILDING,
  REAL_ESTATE__PURCHASE,
  REAL_ESTATE__RECONSTRUCTION,
  PURPOSE_KIND__REAL_ESTATE,
  PURPOSE_KIND__LIQUIDITY,
  PURPOSE_KIND__GOODS,
  PURPOSE_KIND__COMMERCIAL_VEHICLE,
  PURPOSE_KIND__EQUIPMENT,
  PURPOSE_KIND__MACHINERY_AND_TECHNICAL_PLANT,
  PURPOSE_KIND__HARD_SOFTWARE,
  PURPOSE_KIND__DEVELOPMENT_EXPENDITURE,
  PURPOSE_KIND__CORONA,
  PURPOSE_KIND__FINANCE_CHECK,
  PURPOSE_KIND__GUARANTEED_CREDIT,
  PURPOSE_KIND__ADDITIONAL_COSTS,
  PURPOSE_KIND__CONSTRUCTION_INVESTMENT,
  PURPOSE_KIND__INVESTMENT_RESERVE,
  PURPOSE_KIND__LICENSES_INTANGIBLE_ASSETS,
  PURPOSE_KIND__MARKET_ENTRY,
  PURPOSE_KIND__PARTICIPATION,
  PURPOSE_KIND__PREOPERATIONAL_COSTS,
  PURPOSE_KIND__PURCHASE_OR_ACQUISITION_PRICE,
  PURPOSE_KIND__OTHER,
  REAL_ESTATE_KFW_STANDARD__40_PLUS,
  REAL_ESTATE_KFW_STANDARD__40,
  REAL_ESTATE_KFW_STANDARD__55,
  FINANCING_ASSETS_IN_KIND,
  FINANCING_PRODUCT__CORONA_LOAN,
  FINANCING_PRODUCT__EQUITY,
  FINANCING_PRODUCT__EQUITY_FINANCING,
  FINANCING_PRODUCT__GUARANTEED_CREDIT,
  FINANCING_PRODUCT__HOUSE_BANK_LOAN,
  FINANCING_PRODUCT__LEASING,
  FINANCING_PRODUCT__LOAN,
  FINANCING_PRODUCT__MICRO_MEZZANINE,
  FINANCING_PRODUCT__OTHER,
  FINANCING_PRODUCT__OWN_CONTRIBUTION,
  FINANCING_PRODUCT__OVERDRAFT,
  FINANCING_PRODUCT__PROMOTIONAL_LOAN,
  FINANCING_PRODUCT__RELATIVE_LOAN,
  FINANCING_PRODUCT__SILENT_PARTNERSHIP,
  FINANCING_PRODUCT__SUBSIDY,
  FINANCING_PRODUCT__VENDOR_LOAN,
  COLLATERALS_KIND__GUARANTEE,
  COLLATERALS_KIND__CESSION_OF_CREDIT_BALANCES,
  COLLATERALS_KIND__CESSION_OF_LIFE_INSURANCE,
  COLLATERALS_KIND__CESSION_OF_RECEIVABLES,
  COLLATERALS_KIND__FINANCING_OBJECT,
  COLLATERALS_KIND__LAND_CHARGES,
  COLLATERALS_KIND__LAND_CHARGES_ON_FINANCING_OBJECT,
  COLLATERALS_KIND__WAREHOUSE_TRANSFER_BY_WAY_OF_SECURITY,
  COMPANY__INDUSTRY_CONSTRUCTION,
  COMPANY__INDUSTRY_MINING,
  COMPANY__INDUSTRY_PROVISION_SERVICES,
  COMPANY__INDUSTRY_FINANCIAL_AND_INSURANCE,
  COMPANY__INDUSTRY_HOSPITALITY,
  COMPANY__INDUSTRY_HEALTH_AND_SOCIAL,
  COMPANY__INDUSTRY_TRADE,
  COMPANY__INDUSTRY_HANDICRAFT,
  COMPANY__INDUSTRY_REAL_ESTATE,
  COMPANY__INDUSTRY_INFORMATION_AND_COMMUNICATION,
  COMPANY__INDUSTRY_AGRICULTURE_AND_FORESTRY,
  COMPANY__INDUSTRY_NANUFACTURING,
  COMPANY__INDUSTRY_OTHER,
  COMPANY__INDUSTRY_PROCESSING,
  COMPANY__INDUSTRY_TRANSPORT_AND_LOGISTICS,
  COMPANY_CONTACT_PERSON_COMPANY_ROLE__COMPANY_OWNER,
  COMPANY_CONTACT_PERSON_COMPANY_ROLE__ASSOCIATE,
  COMPANY_CONTACT_PERSON_COMPANY_ROLE__MANAGING_DIRECTOR,
  COMPANY_CONTACT_PERSON_COMPANY_ROLE__STAFF,
  COMPANY_CONTACT_PERSON_COMPANY_ROLE__AUTHORIZED_SIGNATORY,
  COMPANY_CONTACT_PERSON_COMPANY_ROLE__BOARD,
  COMPANY_CONTACT_PERSON_COMPANY_ROLE__OTHER,
  REAL_ESTATE_KIND__BUSINESS_BUILDING,
  REAL_ESTATE_KIND__WAREHOUSE,
  REAL_ESTATE_KIND__RESIDENCE,
  REAL_ESTATE_KIND__OFFICE_BUILDING,
  REAL_ESTATE_KIND__SPECIALTY_SHOPPING_CENTER,
  REAL_ESTATE_KIND__HOTEL,
  REAL_ESTATE_KIND__OTHER,
  VEHICLE_KIND__CAR,
  VEHICLE_KIND__UTILITY_VEHICLE,
  VEHICLE_KIND__OTHER,
  MACHINE_CATEGORY__METAL,
  MACHINE_CATEGORY__PLASTIC,
  MACHINE_CATEGORY__WOOD,
  MACHINE_CATEGORY__TOOL,
  MACHINE_CATEGORY__PRINT,
  MACHINE_CATEGORY__CONSTRUCTION,
  MACHINE_CATEGORY__HEALTH,
  MACHINE_CATEGORY__ENERGY,
  MACHINE_CATEGORY__RENEWABLE_ENERGY,
  MACHINE_CATEGORY__FOOD,
  MACHINE_CATEGORY__LOGISTIC,
  MACHINE_CATEGORY__PACKAGING,
  MACHINE_CATEGORY__RECYCLING,
  MACHINE_CATEGORY__AGRICULTURE,
  MACHINE_CATEGORY__TELECOMMUNICATION,
  MACHINE_CATEGORY__OTHER,
  CORONA_LOAN_KIND__AMORTISABLE_LOAN,
  CORONA_LOAN_KIND__ANNUITY_LOAN,
  CORONA_LOAN_FIXED_INTEREST_RATE__FIXED,
  CORONA_LOAN_FIXED_INTEREST_RATE__VARIABLE,
  LOAN_KIND__AMORTISABLE_LOAN,
  LOAN_KIND__ANNUITY_LOAN,
  LOAN_KIND__LOAN_PAYABLE_AT_TERM,
  LOAN_FIXED_INTEREST_RATE__FIXED,
  LOAN_FIXED_INTEREST_RATE__VARIABLE,
  LEASING_AMORTISATION_KIND__FULL_AMORTISATION,
  LEASING_AMORTISATION_KIND__PARTIAL_AMORTISATION,
  LEASING_AMORTISATION_KIND__HIRE_PURCHASE,
  LEASING_AMORTISATION_KIND__UNDETERMINED,
  LEASING_TAKEOVER__NO,
  LEASING_TAKEOVER__UNDECIDED,
  LEASING_TAKEOVER__YES,
  CONTRACT_TYPE__LEASING,
  CONTRACT_TYPE__OWN,
  LEASING_CONTRACT_TYPE__PARTIAL,
  LEASING_CONTRACT_TYPE__FULL,
  LEASING_RATE__CONSTANT,
  LEASING_RATE__CHANGEABLE,
  FINANCING_PLAN__EXPANSION_INVESTMENT,
  FINANCING_PLAN__REPLACEMENT_INVESTMENT,
  FINANCING_PLAN__COMPANY_EXPANSION,
  FINANCING_PLAN__RELOCATION,
  FINANCING_PLAN__BUSINESS_START,
  FINANCING_PLAN__NEW_BRANCH,
  FINANCING_PLAN__OTHER,
  EQUITY_STRUCTURE__CLASSICAL_MEZZANINE,
  EQUITY_STRUCTURE__VENTURE_CAPITAL,
  EQUITY_STRUCTURE__DONT_KNOW_YET,
  COMPANY_ROLE__OKP_ESTABLISHED_ENTREPRENEUR,
  FINANCING_PRODUCT__ONGOING_REVENUE_CASHFLOW,
  FINANCING_PRODUCT__KFW_ERP_FGN_LOAN
} from "./formFields";
import { genderLabels as genderKeys } from "../../data/genderOptions";

export const companyTurnoverKeys = {
  [COMPANY__TURNOVER_CLASS__0_TO_10_THOUSAND]: "unter 10 T €",
  [COMPANY__TURNOVER_CLASS__10_TO_20_THOUSAND]: "10 - 20 T €",
  [COMPANY__TURNOVER_CLASS__20_TO_30_THOUSAND]: "20 - 30 T €",
  [COMPANY__TURNOVER_CLASS__30_TO_40_THOUSAND]: "30 - 40 T €",
  [COMPANY__TURNOVER_CLASS__40_TO_50_THOUSAND]: "40 - 50 T €",
  [COMPANY__TURNOVER_CLASS__50_TO_75_THOUSAND]: "50 - 75 T €",
  [COMPANY__TURNOVER_CLASS__75_TO_100_THOUSAND]: "75 - 100 T €",
  [COMPANY__TURNOVER_CLASS__100_TO_250_THOUSAND]: "100 - 250 T €",
  [COMPANY__TURNOVER_CLASS__250_TO_500_THOUSAND]: "250 - 500 T €",
  [COMPANY__TURNOVER_CLASS__500_THOUSAND_TO_1_MILLION]: "500 T - 1 MIO €",
  [COMPANY__TURNOVER_CLASS__1_MILLION_TO_2_5_MILLION]: "1 - 2.5 MIO €",
  [COMPANY__TURNOVER_CLASS__2_5_TO_5_MILLION]: "2.5 - 5 MIO €",
  [COMPANY__TURNOVER_CLASS__5_TO_10_MILLION]: "5 - 10 MIO €",
  [COMPANY__TURNOVER_CLASS__10_TO_25_MILLION]: "10 - 25 MIO €",
  [COMPANY__TURNOVER_CLASS__25_TO_50_MILLION]: "25 - 50 MIO €",
  [COMPANY__TURNOVER_CLASS__50_TO_100_MILLION]: "50 - 100 MIO €",
  [COMPANY__TURNOVER_CLASS__MORE_THAN_100_MILLION]: "über 100 MIO €"
};

export const companyIndustryKeys = {
  [COMPANY__INDUSTRY_CONSTRUCTION]: "Baugewerbe",
  [COMPANY__INDUSTRY_MINING]: "Bergbau",
  [COMPANY__INDUSTRY_PROVISION_SERVICES]: "Erbringung von Dienstleistungen",
  [COMPANY__INDUSTRY_FINANCIAL_AND_INSURANCE]:
    "Erbringung von Finanz- und Versicherungsdienstleistungen",
  [COMPANY__INDUSTRY_HOSPITALITY]: "Gastgewerbe",
  [COMPANY__INDUSTRY_HEALTH_AND_SOCIAL]: "Gesundheits- und Sozialwesen",
  [COMPANY__INDUSTRY_TRADE]: "Handel",
  [COMPANY__INDUSTRY_HANDICRAFT]: "Handwerk",
  [COMPANY__INDUSTRY_REAL_ESTATE]: "Immobilien- / Wohnungswirtschaft",
  [COMPANY__INDUSTRY_INFORMATION_AND_COMMUNICATION]: "Information und Kommunikation",
  [COMPANY__INDUSTRY_AGRICULTURE_AND_FORESTRY]: "Land- und Forstwirtschaft",
  [COMPANY__INDUSTRY_NANUFACTURING]: "Produzierendes Gewerbe",
  [COMPANY__INDUSTRY_OTHER]: "Sonstiges",
  [COMPANY__INDUSTRY_PROCESSING]: "Verarbeitendes Gewerbe",
  [COMPANY__INDUSTRY_TRANSPORT_AND_LOGISTICS]: "Verkehr und Logistik"
};

export const customerProductKindsKeys = {
  [FINANCING_PRODUCT__LOAN]: "Darlehen",
  [FINANCING_PRODUCT__LEASING]: "Leasing / Mietkauf",
  [FINANCING_PRODUCT__OVERDRAFT]: "Kontokorrentkredit",
  [FINANCING_PRODUCT__EQUITY]: "Eigenkapitalstärkung",
  [FINANCING_PRODUCT__OTHER]: "Sonstiges"
};

export const bankAdvisorProductKindsKeys = {
  [FINANCING_PRODUCT__CORONA_LOAN]: "Darlehen",
  [FINANCING_ASSETS_IN_KIND]: "Sacheinlagen",
  [FINANCING_PRODUCT__EQUITY]: "Eigenmittel",
  [FINANCING_PRODUCT__EQUITY_FINANCING]: "Beteiligungsfinanzierung",
  [FINANCING_PRODUCT__GUARANTEED_CREDIT]: "Avalrahmen / Mietaval",
  [FINANCING_PRODUCT__HOUSE_BANK_LOAN]: "Hausbankdarlehen",
  [FINANCING_PRODUCT__LEASING]: "Leasing",
  [FINANCING_PRODUCT__LOAN]: "Darlehen",
  [FINANCING_PRODUCT__MICRO_MEZZANINE]: "Mikro-Mezzanine",
  [FINANCING_PRODUCT__OTHER]: "Sonstige",
  [FINANCING_PRODUCT__OWN_CONTRIBUTION]: "Eigenleistung",
  [FINANCING_PRODUCT__OVERDRAFT]: "Kontokorrent",
  [FINANCING_PRODUCT__PROMOTIONAL_LOAN]: "Förderdarlehen",
  [FINANCING_PRODUCT__RELATIVE_LOAN]: "Verwandtendarlehen",
  [FINANCING_PRODUCT__SILENT_PARTNERSHIP]: "Stille Beteiligung (MBG)",
  [FINANCING_PRODUCT__SUBSIDY]: "Subvention",
  [FINANCING_PRODUCT__VENDOR_LOAN]: "Verkäuferdarlehen",
  [FINANCING_PRODUCT__ONGOING_REVENUE_CASHFLOW]: "Lfd. Ertrag / Cashflow",
  [FINANCING_PRODUCT__KFW_ERP_FGN_LOAN]: "ERP-Förderkredit für Gründung und Nachfolge"
};

export const realEstateKindKeys = {
  [REAL_ESTATE_KIND__BUSINESS_BUILDING]: "Bürogebäude",
  [REAL_ESTATE_KIND__WAREHOUSE]: "Lager-/ Produktionshalle",
  [REAL_ESTATE_KIND__RESIDENCE]: "Wohn- und Geschäftshaus",
  [REAL_ESTATE_KIND__OFFICE_BUILDING]: "Geschäftshaus",
  [REAL_ESTATE_KIND__SPECIALTY_SHOPPING_CENTER]: "Fachmarktzentrum",
  [REAL_ESTATE_KIND__HOTEL]: "Hotel",
  [REAL_ESTATE_KIND__OTHER]: "Sonstiges"
};

export const vehicleTypeKeys = {
  [VEHICLE_KIND__CAR]: "Pkw",
  [VEHICLE_KIND__UTILITY_VEHICLE]: "Lkw",
  [VEHICLE_KIND__OTHER]: "Sonstiges"
};

export const machineCategoryKeys = {
  [MACHINE_CATEGORY__METAL]: "Metallbearbeitungsmaschinen",
  [MACHINE_CATEGORY__PLASTIC]: "Holzbearbeitungsmaschinen",
  [MACHINE_CATEGORY__WOOD]: "Kunststoffverarbeitungsmaschinen",
  [MACHINE_CATEGORY__TOOL]: "Werkzeugmaschinen",
  [MACHINE_CATEGORY__PRINT]: "Druckmaschinen",
  [MACHINE_CATEGORY__CONSTRUCTION]: "Baumaschinen / -anlagen",
  [MACHINE_CATEGORY__HEALTH]: "Medizintechnik",
  [MACHINE_CATEGORY__ENERGY]: "Energietechnik",
  [MACHINE_CATEGORY__RENEWABLE_ENERGY]: "Energietechnik für erneuerbare Energien",
  [MACHINE_CATEGORY__FOOD]: "Lebensmittelherstellung",
  [MACHINE_CATEGORY__LOGISTIC]: "Lagertechnik u. Logistik",
  [MACHINE_CATEGORY__PACKAGING]: "Verpackungsmaschinen",
  [MACHINE_CATEGORY__RECYCLING]: "Entsorgungs- / Recyclingtechnik",
  [MACHINE_CATEGORY__AGRICULTURE]: "Landmaschinen",
  [MACHINE_CATEGORY__TELECOMMUNICATION]: "Telekommunikationsanlagen",
  [MACHINE_CATEGORY__OTHER]: "Sonstige Maschine / techn. Anlage"
};

const coronaLoanKindKeys = {
  [CORONA_LOAN_KIND__AMORTISABLE_LOAN]: "Tilgungsdarlehen",
  [CORONA_LOAN_KIND__ANNUITY_LOAN]: "Annuitätendarlehen"
};
const coronaLoanFixedInterestRateKeys = {
  [CORONA_LOAN_FIXED_INTEREST_RATE__FIXED]: "Fest",
  [CORONA_LOAN_FIXED_INTEREST_RATE__VARIABLE]: "Variabel"
};

const loanKindKeys = {
  [LOAN_KIND__AMORTISABLE_LOAN]: "Tilgungsdarlehen",
  [LOAN_KIND__ANNUITY_LOAN]: "Annuitätendarlehen",
  [LOAN_KIND__LOAN_PAYABLE_AT_TERM]: "endfälliges Darlehen"
};
const loanFixedInterestRateKeys = {
  [LOAN_FIXED_INTEREST_RATE__FIXED]: "Fest",
  [LOAN_FIXED_INTEREST_RATE__VARIABLE]: "Variabel"
};

const amortisationKindKeys = {
  [LEASING_AMORTISATION_KIND__FULL_AMORTISATION]: "Vollamortisation",
  [LEASING_AMORTISATION_KIND__PARTIAL_AMORTISATION]: "Teilamortisation",
  [LEASING_AMORTISATION_KIND__HIRE_PURCHASE]: "Mietkauf",
  [LEASING_AMORTISATION_KIND__UNDETERMINED]: "Ich möchte jetzt noch keine Entscheidung treffen"
};

const leasingTakeoverKeys = {
  [LEASING_TAKEOVER__YES]: "Ich möchte das Objekt übernehmen.",
  [LEASING_TAKEOVER__NO]: "Ich möchte das Objekt zurückgeben.",
  [LEASING_TAKEOVER__UNDECIDED]: "Ich möchte jetzt noch keine Entscheidung treffen."
};

const companyAnnualNetProfitKeys = {
  [COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__LOSS]: "Verlust",
  [COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__ZERO]: "0",
  [COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__1_TO_10_THOUSAND]: "1 - 10 T €",
  [COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__10_TO_20_THOUSAND]: "10 - 20 T €",
  [COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__20_TO_30_THOUSAND]: "20 - 30 T €",
  [COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__30_TO_40_THOUSAND]: "30 - 40 T €",
  [COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__40_TO_50_THOUSAND]: "40 - 50 T €",
  [COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__50_TO_75_THOUSAND]: "50 - 75 T €",
  [COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__75_TO_100_THOUSAND]: "75 - 100 T €",
  [COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__100_TO_250_THOUSAND]: "100 - 250 T €",
  [COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__250_TO_500_THOUSAND]: "250 - 500 T €",
  [COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__500_TO_750_THOUSAND]: "500 - 750 T €",
  [COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__500_THOUSAND_TO_1_MILLION]: "500 T € - 1 Mio €",
  [COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__750_THOUSAND_TO_1_MILLION]: "750 T € - 1 Mio €",
  [COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__1_TO_2_5_MILLION]: "1 – 2,5 Mio €",
  [COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__1_MILLION_TO_2_5_MILLION]: "1 – 2,5 Mio €",
  [COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__2_5_TO_5_MILLION]: "2.5 – 5 Mio €",
  [COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__5_TO_10_MILLION]: "5 – 10 Mio €",
  [COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__10_TO_25_MILLION]: "10 – 25 Mio €",
  [COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__25_TO_50_MILLION]: "25 – 50 Mio €",
  [COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__10_TO_50_MILLION]: "10 – 50 Mio €",
  [COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__MORE_THAN_50_MILLION]: "über 50 Mio €",
  [COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__50_TO_100_MILLION]: "50 – 100 Mio €",
  [COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__MORE_THAN_100_MILLION]: "über 100 Mio €"
};

const financingProductKeys = {
  [FINANCING_PRODUCT__CORONA_LOAN]: "Darlehen",
  [FINANCING_PRODUCT__LOAN]: "Darlehen",
  [FINANCING_PRODUCT__EQUITY_FINANCING]: "Equity Financing",
  [FINANCING_PRODUCT__LEASING]: "Leasing / Mietkauf",
  [FINANCING_PRODUCT__OVERDRAFT]: "Kontokorrentkredit",
  [FINANCING_PRODUCT__EQUITY]: "Eigenkapitalstärkung",
  [FINANCING_PRODUCT__MICRO_MEZZANINE]: "Mikro-Mezzanine",
  [FINANCING_PRODUCT__OTHER]: "Sonstiges",
  [FINANCING_ASSETS_IN_KIND]: "Sacheinlagen",
  [FINANCING_PRODUCT__OWN_CONTRIBUTION]: "Eigenmittel",
  [FINANCING_PRODUCT__ONGOING_REVENUE_CASHFLOW]: "Lfd. Ertrag / Cashflow",
  [FINANCING_PRODUCT__GUARANTEED_CREDIT]: "Avalrahmen / Mietaval",
  [FINANCING_PRODUCT__HOUSE_BANK_LOAN]: "Hausbankdarlehen",
  [FINANCING_PRODUCT__PROMOTIONAL_LOAN]: "Förderdarlehen",
  [FINANCING_PRODUCT__RELATIVE_LOAN]: "Verwandtendarlehen",
  [FINANCING_PRODUCT__SILENT_PARTNERSHIP]: "Stille Beteiligung (MBG)",
  [FINANCING_PRODUCT__SUBSIDY]: "Subvention",
  [FINANCING_PRODUCT__VENDOR_LOAN]: "Verkäuferdarlehen",
  [FINANCING_PRODUCT__KFW_ERP_FGN_LOAN]: "ERP-Förderkredit für Gründung und Nachfolge"
};

const companyRoleKeys = {
  [COMPANY_CONTACT_PERSON_COMPANY_ROLE__COMPANY_OWNER]: "Alleiniger Firmeninhaber",
  [COMPANY_CONTACT_PERSON_COMPANY_ROLE__ASSOCIATE]: "Gesellschafter",
  [COMPANY_CONTACT_PERSON_COMPANY_ROLE__MANAGING_DIRECTOR]: "Geschäftsführer",
  [COMPANY_CONTACT_PERSON_COMPANY_ROLE__STAFF]: "Mitarbeiter",
  [COMPANY_CONTACT_PERSON_COMPANY_ROLE__AUTHORIZED_SIGNATORY]: "Prokurist",
  [COMPANY_CONTACT_PERSON_COMPANY_ROLE__BOARD]: "Vorstand",
  [COMPANY_CONTACT_PERSON_COMPANY_ROLE__OTHER]: "Sonstiges"
};

const collateralsKindKeys = {
  [COLLATERALS_KIND__GUARANTEE]: "Dritt-Bürgschaft",
  [COLLATERALS_KIND__FINANCING_OBJECT]: "Finanzierungsobjekt",
  [COLLATERALS_KIND__LAND_CHARGES]: "Grundschulden",
  [COLLATERALS_KIND__CESSION_OF_LIFE_INSURANCE]: "Abtretung Lebensversicherung",
  [COLLATERALS_KIND__CESSION_OF_CREDIT_BALANCES]: "Abtretung Bausparvertrag",
  [COLLATERALS_KIND__LAND_CHARGES_ON_FINANCING_OBJECT]: "Sicherungsübereignung Warenlager",
  [COLLATERALS_KIND__CESSION_OF_RECEIVABLES]: "Forderungszession",
  [COLLATERALS_KIND__WAREHOUSE_TRANSFER_BY_WAY_OF_SECURITY]: "Grundschulden am Finanzierungsobjekt"
};

const purposeKindKeys = {
  [PURPOSE_KIND__REAL_ESTATE]: "Immobilie",
  [PURPOSE_KIND__HARD_SOFTWARE]: "Hardware und Software",
  [PURPOSE_KIND__LIQUIDITY]: "Liquidität",
  [PURPOSE_KIND__EQUIPMENT]: "Equipment",
  [PURPOSE_KIND__COMMERCIAL_VEHICLE]: "(Nutz-)Fahrzeuge",
  [PURPOSE_KIND__MACHINERY_AND_TECHNICAL_PLANT]: "Maschinen",
  [PURPOSE_KIND__GOODS]: "Waren und Güter",
  [PURPOSE_KIND__DEVELOPMENT_EXPENDITURE]: "Entwicklungsausgaben",
  [PURPOSE_KIND__FINANCE_CHECK]: "FinanzierungsCheck",
  [PURPOSE_KIND__CORONA]: "Corona-Sofortbürgschaft",
  [PURPOSE_KIND__GUARANTEED_CREDIT]: "Avalrahmen",
  [PURPOSE_KIND__OTHER]: "Sonstige Kosten",
  [PURPOSE_KIND__ADDITIONAL_COSTS]: "Nebenkosten",
  [PURPOSE_KIND__CONSTRUCTION_INVESTMENT]: "Bauliche Investitionen",
  [PURPOSE_KIND__INVESTMENT_RESERVE]: "Investitionsreserve",
  [PURPOSE_KIND__LICENSES_INTANGIBLE_ASSETS]: "Lizenzen / Immaterielle WG",
  [PURPOSE_KIND__MARKET_ENTRY]: "Markterschließung",
  [PURPOSE_KIND__PARTICIPATION]: "Beteiligung",
  [PURPOSE_KIND__PREOPERATIONAL_COSTS]: "Vorlauf- / Anlaufkosten ",
  [PURPOSE_KIND__PURCHASE_OR_ACQUISITION_PRICE]: "Kauf-/Übernahmepreis"
};

const roleKeys = {
  [COMPANY_ROLE__FOUNDER]: "Gründer / Jungunternehmer",
  [COMPANY_ROLE__SUCCESSOR]: "Nachfolger",
  [COMPANY_ROLE__ESTABLISHED_ENTREPRENEUR]: "Etablierter Unternehmer"
};

const okpRoleKeys = {
  [COMPANY_ROLE__FOUNDER]: "Gründung",
  [COMPANY_ROLE__SUCCESSOR]: "Nachfolge",
  [COMPANY_ROLE__OKP_ESTABLISHED_ENTREPRENEUR]: "Etabliertes Unternehmen"
};

const realEstateProjectKeys = {
  [REAL_ESTATE__NEW_BUILDING]: "Neubau",
  [REAL_ESTATE__PURCHASE]: "Kauf",
  [REAL_ESTATE__RECONSTRUCTION]: "Umbau/Modernisierung"
};

const realEstateKfwStandardKeys = {
  [REAL_ESTATE_KFW_STANDARD__40_PLUS]: "KfW-Effizienzhaus 40 Plus",
  [REAL_ESTATE_KFW_STANDARD__40]: "KfW-Effizienzhaus 40",
  [REAL_ESTATE_KFW_STANDARD__55]: "KfW-Effizienzhaus 55"
};

// Leasing inquiry:

const contractTypeKeys = {
  [CONTRACT_TYPE__LEASING]: "Leasing",
  [CONTRACT_TYPE__OWN]: "Mietkauf"
};

const leasingContractTypeKeys = {
  [LEASING_CONTRACT_TYPE__PARTIAL]: "Teilamortisation",
  [LEASING_CONTRACT_TYPE__FULL]: "Vollamortisation"
};

const leasingRateKeys = {
  [LEASING_RATE__CONSTANT]: "konstant",
  [LEASING_RATE__CHANGEABLE]: "abweichend"
};

const leasingFinancingPlanKeys = {
  [FINANCING_PLAN__EXPANSION_INVESTMENT]: "Erweiterungsinvestition",
  [FINANCING_PLAN__REPLACEMENT_INVESTMENT]: "Ersatzinvestition",
  [FINANCING_PLAN__COMPANY_EXPANSION]: "Betriebserweiterung",
  [FINANCING_PLAN__RELOCATION]: "Betriebsverlagerung",
  [FINANCING_PLAN__BUSINESS_START]: "Existenzgründung",
  [FINANCING_PLAN__NEW_BRANCH]: "Neue Filiale",
  [FINANCING_PLAN__OTHER]: "Sonstiges"
};

const equityStructure = {
  [EQUITY_STRUCTURE__CLASSICAL_MEZZANINE]: "Klassisches Mezzanine",
  [EQUITY_STRUCTURE__VENTURE_CAPITAL]: "Venture Capital",
  [EQUITY_STRUCTURE__DONT_KNOW_YET]: "Ich weiß es noch nicht"
};

export const leasingDefaultProduct = "Leasing";

const sourceOfFundsKeys = {
  assets_in_kind: "Sacheinlagen",
  equity: "Eigenmittel",
  loan: "Darlehen",
  leasing: "Leasing",
  overdraft: "Kontokorrent",
  equity_financing: "Beteiligungsfinanzierung",
  micro_mezzanine: "Mikro-Mezzanine",
  guaranteed_credit: "Avalrahmen / Mietaval",
  vendor_loan: "Verkäuferdarlehen",
  relative_loan: "Verwandtendarlehen",
  subsidy: "Subvention",
  house_bank_loan: "Hausbankdarlehen",
  promotional_loan: "Förderdarlehen",
  silent_partnership: "Stille Beteiligung (MBG)",
  other: "Sonstige",
  kfw_erp_fgn_loan: "ERP-Förderkredit für Gründung und Nachfolge",
  own_contribution: "Eigenleistung",
  ongoing_revenue_cashflow: "Lfd. Ertrag / Cashflow"
};

export const mapRealEstateKfwStandardKeys = (value: string) => realEstateKfwStandardKeys[value];
export const mapRealEstateProject = (value: string) => realEstateProjectKeys[value];
export const mapRole = (value: string) => roleKeys[value];
export const mapOkpRole = (value: string) => okpRoleKeys[value];
export const mapSourceOfFundsKeys = (value: string) => sourceOfFundsKeys[value] || value;
export const mapPurposeKind = (value: string) => purposeKindKeys[value] || value;
export const mapCollateralsKind = (value: string) => collateralsKindKeys[value];
export const mapCompanyRole = (value: string) => companyRoleKeys[value];
export const mapFinancingProduct = (value: string) => financingProductKeys[value];
export const mapCompanyAnnualNetProfit = (value: string) => companyAnnualNetProfitKeys[value];
export const mapLeasingTakeover = (value: string) => leasingTakeoverKeys[value];
export const mapAmortisationKind = (value: string) => amortisationKindKeys[value];
export const mapCoronaLoanFixedInterestRate = (value: string) =>
  coronaLoanFixedInterestRateKeys[value];
export const mapCoronaLoanKind = (value: string) => coronaLoanKindKeys[value];
export const mapLoanFixedInterestRate = (value: string) => loanFixedInterestRateKeys[value];
export const mapLoanKind = (value: string) => loanKindKeys[value];
export const mapMachineCategory = (value: string) => machineCategoryKeys[value];
export const mapVehicleType = (value: string) => vehicleTypeKeys[value];
export const mapRealEstateKind = (value: string) => realEstateKindKeys[value];
export const mapCompanyIndustry = (value: string) => companyIndustryKeys[value];
export const mapCompanyTurnover = (value: string) => companyTurnoverKeys[value];
export const mapBankAdvisorProducts = (value: string) => bankAdvisorProductKindsKeys[value];
export const mapCustomerProducts = (value: string) => customerProductKindsKeys[value];
export const mapEquityStructure = (value: string) => equityStructure[value];
export const mapBoolean = (value: boolean) => {
  if (value === false) return "Nein";
  if (value === true) return "Ja";
  return "-";
};

export const mapSupport = (isCustomer: boolean) => (value: boolean) =>
  // eslint-disable-next-line no-nested-ternary
  value
    ? isCustomer
      ? "Ich möchte Unterstützung eines Experten haben"
      : "Kunde möchte Unterstützung eines Experten haben"
    : isCustomer
      ? "Ich habe bereits eine eigene Vorstellung"
      : "Kunde hat bereits eine eigene Vorstellung";
export const mapContractType = (value: string) => contractTypeKeys[value];
export const mapLeasingContactType = (value: string) => leasingContractTypeKeys[value];
export const mapLeasingRate = (value: string) => leasingRateKeys[value];
export const mapLeasingFinancingPlan = (value: string) => leasingFinancingPlanKeys[value];
export const mapGender = (value: string) => genderKeys[value] || "-";

type purposeKindType = {
  kind: string,
  value: number
};

export const getKind = (purposeArray: Array<purposeKindType>, purposeKind: string) => {
  const foundKind = purposeArray.find(({ kind }) => kind === purposeKind);
  return foundKind || "";
};
